import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './Login.css';

function Login() {
  const navigate = useNavigate();
  const { login, isAuthenticated, loading: authLoading, error: authError } = useAuth();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const result = await login(username, password);

    if (!result.success) {
      setError(result.error || 'Login failed. Please try again.');
    }

    setIsLoading(false);
  };

  const handleTestLogin = async (testUsername) => {
    setError('');
    setIsLoading(true);

    const result = await login(testUsername, 
      testUsername === 'admin' ? 'admin123' :
      testUsername === 'manager' ? 'manager123' :
      testUsername === 'staff' ? 'staff123' : 'customer123'
    );

    if (!result.success) {
      setError(result.error || 'Login failed');
    }

    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-wrapper">
        <div className="login-card">
          <div className="login-header">
            <div className="login-brand" aria-label="ZOBOX Enterprise Suite">
              <span className="login-brand-mark"><img src="/assets/zoboxPhoneIcon.png" alt="" /></span>
              <span className="login-brand-copy">
                <strong>ZOBOX</strong>
                <small>Enterprise Suite</small>
              </span>
            </div>
            <h1>Welcome back</h1>
            <p>Sign in to your secure business workspace</p>
          </div>

          {(error || authError) && (
            <div className="login-error-message">
              <span>⚠️</span>
              {error || authError}
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                placeholder="admin / manager / staff / customer"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={isLoading || authLoading}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-input-wrapper">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={isLoading || authLoading}
                  required
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={isLoading || authLoading}
                >
                  {showPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>

            <button 
              type="submit" 
              className="login-button" 
              disabled={isLoading || authLoading}
            >
              {isLoading || authLoading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="divider">Staging Test Users</div>

          <div className="test-credentials">
            <button
              type="button"
              className="test-btn admin"
              onClick={() => handleTestLogin('admin')}
              disabled={isLoading || authLoading}
            >
              👨‍💼 Admin
            </button>
            <button
              type="button"
              className="test-btn manager"
              onClick={() => handleTestLogin('manager')}
              disabled={isLoading || authLoading}
            >
              👨‍💻 Manager
            </button>
            <button
              type="button"
              className="test-btn staff"
              onClick={() => handleTestLogin('staff')}
              disabled={isLoading || authLoading}
            >
              👩‍💼 Staff
            </button>
            <button
              type="button"
              className="test-btn customer"
              onClick={() => handleTestLogin('customer')}
              disabled={isLoading || authLoading}
            >
              👤 Customer
            </button>
          </div>

          <div className="login-footer">
            <small>Environment: <strong>Staging</strong></small>
            <small>JWT Authentication Enabled</small>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
